var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.71 19.2899L17 15.6099C18.4401 13.8143 19.1375 11.5352 18.9488 9.24121C18.7601 6.94721 17.6997 4.81269 15.9855 3.27655C14.2714 1.74041 12.0338 0.919414 9.73293 0.982375C7.43205 1.04534 5.24273 1.98747 3.61515 3.61505C1.98757 5.24263 1.04544 7.43194 0.982482 9.73283C0.919521 12.0337 1.74052 14.2713 3.27666 15.9854C4.81279 17.6996 6.94731 18.76 9.24131 18.9487C11.5353 19.1374 13.8144 18.44 15.61 16.9999L19.29 20.6799C19.383 20.7736 19.4936 20.848 19.6154 20.8988C19.7373 20.9496 19.868 20.9757 20 20.9757C20.132 20.9757 20.2627 20.9496 20.3846 20.8988C20.5064 20.848 20.617 20.7736 20.71 20.6799C20.8903 20.4934 20.991 20.2442 20.991 19.9849C20.991 19.7256 20.8903 19.4764 20.71 19.2899ZM10 16.9999C8.61554 16.9999 7.26216 16.5894 6.11102 15.8202C4.95988 15.051 4.06267 13.9578 3.53285 12.6787C3.00304 11.3996 2.86442 9.99214 3.13451 8.63427C3.40461 7.27641 4.0713 6.02913 5.05026 5.05016C6.02923 4.07119 7.27651 3.4045 8.63438 3.13441C9.99225 2.86431 11.3997 3.00293 12.6788 3.53275C13.9579 4.06256 15.0511 4.95977 15.8203 6.11091C16.5895 7.26206 17 8.61544 17 9.99991C17 11.8564 16.2625 13.6369 14.9498 14.9497C13.637 16.2624 11.8565 16.9999 10 16.9999Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.589aa3bc489d649aac166ad8961833f8.svg";
export { ForwardRef as ReactComponent };